<nav aria-label="Priečinky">
    <div>
    <button type="button" class="govuk-button" (click)="openCompose()">
      Nová správa
    </button>
  </div>
  <h2 class="govuk-heading-m govuk-!-margin-bottom-3">Menu</h2>

  <p class="govuk-hint" *ngIf="loading()">Načítavam priečinky…</p>

  <div class="app-folders-error" *ngIf="!loading() && error()">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0;color:#d4351c">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    <span>{{ error() }}</span>
  </div>

  <ng-container *ngIf="!loading() && !error()">
    <ng-container
      [ngTemplateOutlet]="folderTree"
      [ngTemplateOutletContext]="{ nodes: filteredTree(), level: 0 }">
    </ng-container>
  </ng-container>
</nav>

<ng-template #folderTree let-nodes="nodes" let-level="level">
  <ul class="govuk-list" [class.app-folder-sublist]="level > 0">
    <li *ngFor="let f of nodes; trackBy: trackById" class="app-folder-item"
      [class.app-folder-item--child]="level > 0">
      <a href="#" class="govuk-link app-folder-link" [class.app-folder-link--selected]="isSelected(f)"
        [class.app-folder-link--child]="level > 0" [style.padding-left.px]="level === 0 ? 10 : 10 + 32 + (level - 1) * 24"
        [attr.aria-current]="isSelected(f) ? 'page' : null" (click)="pick(f); $event.preventDefault()"
        [attr.aria-label]="'Otvoriť priečinok ' + displayFolderName(f)">
        <img [src]="getFolderIconPath(f)" class="app-folder-icon" width="18" height="18" alt="" aria-hidden="true">
        {{ displayFolderName(f) }}
      </a>

      <ng-container *ngIf="childrenOf(f).length > 0"
        [ngTemplateOutlet]="folderTree"
        [ngTemplateOutletContext]="{ nodes: childrenOf(f), level: level + 1 }">
      </ng-container>
    </li>
  </ul>
</ng-template>
